import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Input from "../../../../componentes/input/input";
import Textarea from "../../../../componentes/input/textarea";
import InputFormat from "../../../../componentes/inputMask/inputMask";
import Button from "../../../../componentes/button/button";
import { CustomDropdown } from "../../../../componentes/dropdown/CustomDropdown";
import FilialService from "../../../../services/resource/filialService";
import ClienteService from "../../../../services/resource/clienteService";
import SubCanalAtivoService from "../../../../services/resource/subCanalAtivoService";
import NovaSolicitacaoLayout from "../shared/NovaSolicitacaoLayout";
import { useRascunhoFormulario } from "../../Rascunho/RascunhoContext";
import { listaDoRascunho, mesclarComPadrao } from "../../../../utils/solicitacoes/rascunhoStorage";
import { enviarAnexosStaged } from "../../../../utils/solicitacoes/anexosStaged";
import { enviarComentariosStaged } from "../../../../utils/solicitacoes/comentariosStaged";
import DateMasked from "../../../../componentes/inputMask/DateMasked";

const filialService = new FilialService();
const clienteService = new ClienteService();
const subCanalService = new SubCanalAtivoService();

const CODIGO_CLIENTE_REGEX = /^\d{4}-\d{4}$/;

// Exigido só no frontend (web e mobile) — o backend não valida isso, ver conversa com o usuário.
const ANEXOS_OBRIGATORIOS_NOVO_CADASTRO = ["Documento", "Comprovante de Endereço", "Foto do PDV", "Foto da Localização"];

const TIPO_SOLICITACAO_OPTIONS = [
    { value: "NOVO_CADASTRO", label: "Novo Cadastro" },
    { value: "ALTERACAO_CADASTRO", label: "Alteração de Cadastro" },
    { value: "ALTERACAO_ENDERECO", label: "Alteração de Endereço" },
    { value: "TROCA_RAZAO_SOCIAL", label: "Troca de Razão Social" },
    { value: "REATIVACAO", label: "Reativação" },
];

const TIPO_PESSOA_OPTIONS = [
    { value: "PESSOA_FISICA", label: "Pessoa Física" },
    { value: "PESSOA_JURIDICA", label: "Pessoa Jurídica" },
];

const DIA_VISITA_OPTIONS = [
    { value: "SEGUNDA_FEIRA", label: "Segunda-feira" },
    { value: "TERCA_FEIRA", label: "Terça-feira" },
    { value: "QUARTA_FEIRA", label: "Quarta-feira" },
    { value: "QUINTA_FEIRA", label: "Quinta-feira" },
    { value: "SEXTA_FEIRA", label: "Sexta-feira" },
    { value: "SABADO", label: "Sábado" },
];

const SIM_NAO_OPTIONS = [
    { value: true, label: "Sim" },
    { value: false, label: "Não" },
];

const ESTADO_CIVIL_OPTIONS = [
    { value: "SOLTEIRO", label: "Solteiro(a)" },
    { value: "CASADO", label: "Casado(a)" },
    { value: "DIVORCIADO", label: "Divorciado(a)" },
    { value: "VIUVO", label: "Viúvo(a)" },
    { value: "UNIAO_ESTAVEL", label: "União Estável" },
];

const inicial = {
    tipoSolicitacao: null,
    filialId: null,
    clienteCodigo: "",
    clienteEncontrado: null,
    nomeCliente: "",
    dataNascimento: "",
    cpf: "",
    tipoPessoa: null,
    cnpj: "",
    situacaoCadastral: "",
    razaoSocial: "",
    fantasia: "",
    inscricaoEstadual: "",
    email: "",
    telefone1: "",
    nomeContato1: "",
    telefone2: "",
    nomeContato2: "",
    cep: "",
    rua: "",
    numero: "",
    bairro: "",
    cidade: "",
    estado: "",
    complemento: "",
    pontoReferencia: "",
    estadoCivil: "",
    profissao: "",
    subCanalId: null,
    diaVisita: null,
    rota: "",
    possuiEquipamento: false,
    quantidadeEquipamentos: "",
    possuiVasilhame: false,
    quantidadeVasilhames: "",
    observacoes: "",
};

export default function NovaSolicitacaoCadastroClienteForm({ service, etapaInicialExigeAnexo, onCriada, encaminhar }) {
    const [form, setForm] = useState(inicial);
    const [anexos, setAnexos] = useState([]);
    const [comentarios, setComentarios] = useState([]);

    // Rascunho (botão "Salvar rascunho" da página) — só campos, anexos ficam de fora.
    useRascunhoFormulario(
        () => ({ form, comentarios }),
        dados => {
            setForm(mesclarComPadrao(inicial, dados.form));
            setComentarios(listaDoRascunho(dados.comentarios));
        },
    );
    const [unidades, setUnidades] = useState([]);
    const [subCanais, setSubCanais] = useState([]);
    const [buscandoCliente, setBuscandoCliente] = useState(false);
    const [buscandoCep, setBuscandoCep] = useState(false);
    const [buscandoCnpj, setBuscandoCnpj] = useState(false);
    const [enviando, setEnviando] = useState(false);

    useEffect(() => {
        filialService.listarAtivas().then(res => setUnidades(res.data)).catch(() => setUnidades([]));
        subCanalService.listarAtivos().then(res => setSubCanais(res.data)).catch(() => setSubCanais([]));
    }, []);

    function set(campo, valor) {
        setForm(prev => ({ ...prev, [campo]: valor }));
    }

    const exigeCliente = form.tipoSolicitacao && form.tipoSolicitacao !== "NOVO_CADASTRO";
    const anexosObrigatorios = form.tipoSolicitacao === "NOVO_CADASTRO" ? ANEXOS_OBRIGATORIOS_NOVO_CADASTRO : [];

    function aoMudarCodigoCliente(valor) {
        const novoValor = valor || "";
        if (!CODIGO_CLIENTE_REGEX.test(novoValor)) {
            setForm(prev => ({ ...prev, clienteCodigo: novoValor, clienteEncontrado: null }));
            return;
        }
        setBuscandoCliente(true);
        clienteService.buscarPorCodigo(novoValor)
            .then(res => {
                const c = res.data;
                if (c.encontrado) {
                    setForm(prev => ({
                        ...prev, clienteCodigo: novoValor, clienteEncontrado: true,
                        razaoSocial: c.razaoSocial || "", fantasia: c.fantasia || "",
                        cidade: c.cidade || "", estado: c.estado || "", bairro: c.bairro || "",
                    }));
                } else {
                    setForm(prev => ({ ...prev, clienteCodigo: novoValor, clienteEncontrado: false }));
                    toast.info("Cliente não encontrado. Preencha os dados manualmente.");
                }
            })
            .catch(() => toast.error("Erro ao buscar cliente."))
            .finally(() => setBuscandoCliente(false));
    }

    function aoSairDoCep() {
        const cepLimpo = (form.cep || "").replace(/\D/g, "");
        if (cepLimpo.length !== 8) return;
        setBuscandoCep(true);
        fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`)
            .then(res => res.json())
            .then(data => {
                if (data.erro) {
                    toast.info("CEP não encontrado. Preencha o endereço manualmente.");
                    return;
                }
                setForm(prev => ({
                    ...prev,
                    rua: data.logradouro || prev.rua,
                    bairro: data.bairro || prev.bairro,
                    cidade: data.localidade || prev.cidade,
                    estado: data.uf || prev.estado,
                    complemento: data.complemento || prev.complemento,
                }));
            })
            .catch(() => toast.error("Erro ao consultar o CEP."))
            .finally(() => setBuscandoCep(false));
    }

    function aoSairDoCnpj() {
        const cnpjLimpo = (form.cnpj || "").replace(/\D/g, "");
        if (cnpjLimpo.length !== 14) return;
        setBuscandoCnpj(true);
        fetch(`https://brasilapi.com.br/api/cnpj/v1/${cnpjLimpo}`)
            .then(res => {
                if (!res.ok) throw new Error("CNPJ não encontrado.");
                return res.json();
            })
            .then(data => {
                setForm(prev => ({
                    ...prev,
                    razaoSocial: data.razao_social || prev.razaoSocial,
                    fantasia: data.nome_fantasia || prev.fantasia,
                    situacaoCadastral: data.descricao_situacao_cadastral || prev.situacaoCadastral,
                    cep: data.cep ? String(data.cep) : prev.cep,
                    rua: data.logradouro || prev.rua,
                    numero: data.numero || prev.numero,
                    bairro: data.bairro || prev.bairro,
                    cidade: data.municipio || prev.cidade,
                    estado: data.uf || prev.estado,
                    complemento: data.complemento || prev.complemento,
                    email: data.email || prev.email,
                    telefone1: data.ddd_telefone_1 || prev.telefone1,
                }));
            })
            .catch(() => toast.info("CNPJ não encontrado. Preencha os dados manualmente."))
            .finally(() => setBuscandoCnpj(false));
    }

    const camposClienteDesabilitados = form.clienteEncontrado === true;

    function validar() {
        if (!form.tipoSolicitacao || !form.filialId) {
            toast.error("Preencha todos os campos obrigatórios.");
            return false;
        }
        if (exigeCliente && !CODIGO_CLIENTE_REGEX.test(form.clienteCodigo)) {
            toast.error("Informe o código do cliente no formato 9999-9999.");
            return false;
        }
        if (anexosObrigatorios.length > 0) {
            const faltando = anexosObrigatorios.filter(
                tipo => !anexos.some(item => item.descricao?.trim().toLowerCase() === tipo.toLowerCase())
            );
            if (faltando.length > 0) {
                toast.error(`Para um Novo Cadastro, é necessário anexar: ${faltando.join(", ")}.`);
                return false;
            }
        } else if (etapaInicialExigeAnexo && anexos.length === 0) {
            toast.error("É necessário anexar pelo menos um documento para concluir esta etapa.");
            return false;
        }
        return true;
    }

    async function enviar() {
        if (!validar()) return;

        let usuarioEscolhidoId;
        try {
            usuarioEscolhidoId = await encaminhar("ETAPA_2_ANALISE_SUPERVISOR");
        } catch {
            return;
        }

        setEnviando(true);
        service.criarSolicitacao({
            ...form,
            usuarioEscolhidoId,
            quantidadeEquipamentos: form.possuiEquipamento && form.quantidadeEquipamentos !== "" ? Number(form.quantidadeEquipamentos) : null,
            quantidadeVasilhames: form.possuiVasilhame && form.quantidadeVasilhames !== "" ? Number(form.quantidadeVasilhames) : null,
            clienteCodigo: exigeCliente ? form.clienteCodigo : null,
        })
            .then(async res => {
                const [{ falha: falhaAnexos }, { falha: falhaComentarios }] = await Promise.all([
                    enviarAnexosStaged(res.data.id, anexos),
                    enviarComentariosStaged(res.data.id, comentarios),
                ]);
                if (falhaAnexos.length > 0 || falhaComentarios.length > 0) {
                    const partes = [];
                    if (falhaAnexos.length > 0) partes.push(`${falhaAnexos.length} anexo(s) (${falhaAnexos.map(f => `${f.arquivo.name}: ${f.erro}`).join(", ")})`);
                    if (falhaComentarios.length > 0) partes.push(`${falhaComentarios.length} comentário(s)`);
                    toast.error(`Solicitação criada, mas houve falha ao enviar: ${partes.join(" e ")}.`);
                } 
                onCriada(res.data);
            })
            .catch(error => console.error("Erro ao criar solicitação de cadastro de cliente", error))
            .finally(() => setEnviando(false));
    }

    return (
        <NovaSolicitacaoLayout
            anexos={anexos}
            onAnexosChange={setAnexos}
            comentarios={comentarios}
            onComentariosChange={setComentarios}
            etapaInicialExigeAnexo={etapaInicialExigeAnexo}
            anexosObrigatorios={anexosObrigatorios}
        >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                    <label className="text-sm font-medium text-foreground/80 block mb-1.5">Tipo da Solicitação <span className="text-destructive">*</span></label>
                    <CustomDropdown value={form.tipoSolicitacao} onChange={e => set("tipoSolicitacao", e.value)} options={TIPO_SOLICITACAO_OPTIONS} placeholder="Selecione" />
                </div>
                <div>
                    <label className="text-sm font-medium text-foreground/80 block mb-1.5">Filial <span className="text-destructive">*</span></label>
                    <CustomDropdown value={form.filialId} onChange={e => set("filialId", e.value)} options={unidades} optionValue="id" optionLabel="nome" placeholder="Selecione" filter />
                </div>
            </div>

            {exigeCliente && (
                <>
                    <h3 className="text-sm font-semibold text-foreground mt-2">Cliente</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        <InputFormat
                            label="Código do Cliente"
                            required
                            mask="9999-9999"
                            value={form.clienteCodigo}
                            onChange={aoMudarCodigoCliente}
                            placeholder="0000-0000"
                        />
                    </div>
                    {buscandoCliente && <p className="text-xs text-muted-foreground -mt-2">Buscando cliente...</p>}
                    {form.clienteEncontrado === false && <p className="text-xs text-amber-600 -mt-2">Cliente não encontrado — preencha os dados manualmente.</p>}
                </>
            )}

            <h3 className="text-sm font-semibold text-foreground mt-2">Dados Pessoais</h3>
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                <div className="col-span-3">
                    <Input label="Nome do Cliente" value={form.nomeCliente} onChange={e => set("nomeCliente", e.target.value)} />
                </div>
                <DateMasked type="date" label="Data de Nascimento" value={form.dataNascimento} onChange={e => set("dataNascimento", e)} />
                <InputFormat label="CPF" mask="999.999.999-99" placeholder="000.000.000-00" value={form.cpf} onChange={v => set("cpf", v)} />
                <CustomDropdown label="Tipo de Pessoa" value={form.tipoPessoa} onChange={e => set("tipoPessoa", e.value)} options={TIPO_PESSOA_OPTIONS} placeholder="Selecione" />
                <InputFormat
                    label="CNPJ"
                    mask="99.999.999/9999-99"
                    placeholder="00.000.000/0000-00"
                    value={form.cnpj}
                    onChange={v => set("cnpj", v)}
                    onBlur={aoSairDoCnpj}
                    helpText={buscandoCnpj && "Buscando dados do CNPJ..."}
                />
                <Input label="Situação Cadastral" value={form.situacaoCadastral} onChange={e => set("situacaoCadastral", e.target.value)} />
            </div>

            <h3 className="text-sm font-semibold text-foreground mt-2">Dados Empresariais</h3>
            <div className="grid grid-cols-1 sm:grid-cols-6 gap-4">
                <div className="col-span-3">
                    <Input label="Razão Social" disabled={camposClienteDesabilitados} value={form.razaoSocial} onChange={e => set("razaoSocial", e.target.value)} />
                </div>
                <div className="col-span-2">
                    <Input label="Nome Fantasia" disabled={camposClienteDesabilitados} value={form.fantasia} onChange={e => set("fantasia", e.target.value)} />
                </div>
                <Input label="Inscrição Estadual" value={form.inscricaoEstadual} onChange={e => set("inscricaoEstadual", e.target.value)} />
            </div>

            <h3 className="text-sm font-semibold text-foreground mt-2">Contato</h3>
            <div className="grid grid-cols-1 sm:grid-cols-6 gap-4">
                <div className="col-span-2">
                    <Input label="E-mail" value={form.email} onChange={e => set("email", e.target.value)} />
                </div>
                <Input label="Telefone I" value={form.telefone1} onChange={e => set("telefone1", e.target.value)} />
                <Input label="Nome Contato I" value={form.nomeContato1} onChange={e => set("nomeContato1", e.target.value)} />
                <Input label="Telefone II" value={form.telefone2} onChange={e => set("telefone2", e.target.value)} />
                <Input label="Nome Contato II" value={form.nomeContato2} onChange={e => set("nomeContato2", e.target.value)} />
            </div>

            <h3 className="text-sm font-semibold text-foreground mt-2">Endereço</h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <Input
                    label="CEP"
                    value={form.cep}
                    onChange={e => set("cep", e.target.value)}
                    onBlur={aoSairDoCep}
                    placeholder="00000-000"
                    helpText={buscandoCep && <p className="text-xs text-muted-foreground -mt-2">Buscando CEP...</p>}
                />

                <Input label="Rua" value={form.rua} onChange={e => set("rua", e.target.value)} />
                <Input label="Número" value={form.numero} onChange={e => set("numero", e.target.value)} />
                <Input label="Bairro" disabled={camposClienteDesabilitados} value={form.bairro} onChange={e => set("bairro", e.target.value)} />

                <Input label="Cidade" disabled={camposClienteDesabilitados} value={form.cidade} onChange={e => set("cidade", e.target.value)} />
                <Input label="Estado" disabled={camposClienteDesabilitados} value={form.estado} onChange={e => set("estado", e.target.value)} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <Input label="Complemento" value={form.complemento} onChange={e => set("complemento", e.target.value)} />
                <Input label="Ponto de Referência" value={form.pontoReferencia} onChange={e => set("pontoReferencia", e.target.value)} />
            </div>

            <h3 className="text-sm font-semibold text-foreground mt-2">Dados Complementares</h3>
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                <CustomDropdown label="Estado Civil" value={form.estadoCivil} onChange={e => set("estadoCivil", e.value)} options={ESTADO_CIVIL_OPTIONS} placeholder="Selecione" showClear />
                <Input label="Profissão" value={form.profissao} onChange={e => set("profissao", e.target.value)} />

                <CustomDropdown label="SubCanal" value={form.subCanalId} onChange={e => set("subCanalId", e.value)} options={subCanais} optionValue="id" optionLabel="nome" placeholder="Selecione" filter showClear />
                <CustomDropdown label="Dia de Visita" value={form.diaVisita} onChange={e => set("diaVisita", e.value)} options={DIA_VISITA_OPTIONS} placeholder="Selecione" showClear />
            </div>

            <h3 className="text-sm font-semibold text-foreground mt-2">Outras Informações</h3>
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                <Input label="Rota" value={form.rota} onChange={e => set("rota", e.target.value)} />

                <CustomDropdown label="PDV possui equipamento?" value={form.possuiEquipamento} onChange={e => set("possuiEquipamento", e.value)} options={SIM_NAO_OPTIONS} />
                {form.possuiEquipamento && (
                    <Input type="number" label="Quantidade de Equipamentos" value={form.quantidadeEquipamentos} onChange={e => set("quantidadeEquipamentos", e.target.value)} />
                )}
                <CustomDropdown label="PDV possui vasilhames?" value={form.possuiVasilhame} onChange={e => set("possuiVasilhame", e.value)} options={SIM_NAO_OPTIONS} />
                {form.possuiVasilhame && (
                    <Input type="number" label="Quantidade de Vasilhames" value={form.quantidadeVasilhames} onChange={e => set("quantidadeVasilhames", e.target.value)} />
                )}
            </div>

            <Textarea label="Observações" value={form.observacoes} onChange={e => set("observacoes", e.target.value)} rows={3} />

            <div className="flex justify-end">
                <Button variant="blue" label="Solicitar cadastro" iconLeft="fa fa-paper-plane" loading={enviando} onClick={enviar} />
            </div>
        </NovaSolicitacaoLayout>
    );
}
